var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperQ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 77,
    viewBox: "0 0 55 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6512 38.232C54.6512 17.7264 42.3632 0.753601 27.3872 0.753601C12.488 0.753601 0.200012 17.7264 0.200012 38.232C0.200012 58.7376 12.4112 75.7872 27.3872 75.7872C33.992 75.7872 40.0592 72.4848 44.2064 67.8L51.5024 76.632L54.6512 73.944L46.8176 64.6512C51.5024 58.2768 54.6512 48.7536 54.6512 38.232ZM44.1296 61.4256L35.4512 50.9808L32.3024 53.592L41.5952 64.728C37.9856 68.952 32.9168 71.7168 27.3872 71.7168C14.6384 71.7168 4.27041 56.8944 4.27041 38.232C4.27041 19.6464 14.6384 4.824 27.3872 4.824C40.2128 4.824 50.504 19.6464 50.504 38.232C50.5808 47.6784 47.8928 56.0496 44.1296 61.4256Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperQ);
export default __webpack_public_path__ + "static/media/UPPER_Q.1ba563b082068c222180c53db758e75e.svg";
export { ForwardRef as ReactComponent };